module.exports = __webpack_public_path__ + "img/jane-johnson.1cf62c38.png";